<template>
  <v-card max-width="1200" class="sigfloCard elevation-0 sigfloNeutralBorder150">
    <v-card-subtitle class="ml-2 pt-4">
      <div class="text-h4 font-weight-bold black--text">{{ project.name }}</div>
      <div>
        <span class="font-weight-bold">Budget:</span>
        ${{ formatPrice(project.budget) }}
      </div>
      <div>
        <span class="font-weight-bold">Completion Date:</span>
        {{ formatDate(project.completionDate) }}
      </div>
      <div><span class="font-weight-bold">Notes:</span> {{ project.notes }}</div>
    </v-card-subtitle>
    <v-card-subtitle>Total: ${{ project ? formatPrice(project.sellPrice) : '-' }}</v-card-subtitle>
    <v-card-text v-if="project">
      <v-list-group :value="true" prepend-icon="mdi-chart-donut" v-for="system in project.systems" :key="system.id">
        <template v-slot:prependIcon
          ><v-avatar size="60" color="white" class="mr-15">
            <v-progress-circular
              :color="getProgressColor(system.percentComplete)"
              :value="system.percentComplete"
              size="50"
              width="5"
              ><span class="progressCircleText progressCircleTextSmall"
                >{{ system.percentComplete }}%</span
              ></v-progress-circular
            >
          </v-avatar></template
        >
        <template v-slot:activator>
          <v-list-item-title class="text-h6">{{ system.name }}</v-list-item-title>

          <v-list-item-subtitle class="text-right text-h6"> ${{ formatPrice(system.sellPrice) }} </v-list-item-subtitle>
        </template>

        <v-list-group
          :value="false"
          no-action
          sub-group
          v-for="subsystem in system.subsystems"
          :key="subsystem.id"
          @click="getSubsystemDetails(system.id, subsystem.id)"
        >
          <template v-slot:activator>
            <v-list-item-content>
              <v-list-item-title class="grey--text text-body-1 py-0">
                <v-row>
                  <v-col class="percentageColumn">
                    <v-avatar size="60" color="white" class="mr-15">
                      <v-progress-circular
                        :color="getProgressColor(subsystem.percentComplete)"
                        :value="subsystem.percentComplete"
                        size="50"
                        width="5"
                        ><span class="progressCircleText progressCircleTextSmall"
                          >{{ subsystem.percentComplete }}%</span
                        ></v-progress-circular
                      >
                    </v-avatar>
                  </v-col>
                  <v-col class="pb-0"
                    >{{ subsystem.name }}<br />
                    <span class="text-caption grey-text text-capitalize">{{ subsystem.description }}</span></v-col
                  >
                  <v-col class="mr-16 text-right text-body-1">${{ formatPrice(subsystem.sellPrice) }}</v-col>
                </v-row>
              </v-list-item-title>
            </v-list-item-content>
          </template>
          <v-card :loading="loadingComponentModels" class="pl-16 pt-2">
            <!-- new Product List -->
            <v-data-table
              dense
              :headers="productHeaders"
              :items="consolidatedProductModels(subsystem)"
              class="elevation-0"
              hide-default-footer
              :items-per-page="consolidatedProductModels(subsystem).length"
            >
              <template v-slot:item.type="{ item }">
                <td @click="openSubsystem(subsystem.systemId, subsystem.id, item.stepIndex)" class="pointer">
                  <v-avatar
                    @click="openSubsystem(subsystem.systemId, subsystem.id, item.stepIndex)"
                    size="24px"
                    v-show="item.status != ''"
                    class="stepButton mb-1 elevation-0 mr-4"
                    :class="getStepButtonClass(item)"
                    s
                    :color="getStepColor(item, item.status)"
                  >
                    <v-icon x-small color="white">{{ getStepIcon(item) }}</v-icon>
                  </v-avatar>
                  <span v-show="item.status == '' && !item.hasError" class="ml-12 grey--text">{{ item.type }}</span>
                  <span v-show="item.status == '' && item.hasError" class="ml-12 red--text">{{ item.type }}</span>
                  <span v-show="item.status != ''">{{ item.type }}</span>
                </td>
              </template>
              <template v-slot:item.product="{ item }">
                <td style="width: 400px">
                  <span v-show="item.status == '' && !item.hasError" class="ml-8 grey--text">
                    {{ item.product }}
                    <span v-show="item.customerSupplied"
                      ><v-chip class="ml-4" x-small color="#32FF98">Customer Supplied</v-chip></span
                    >
                  </span>
                  <span v-show="item.hasError" class="red--text">{{ item.product }}</span>
                  <span v-show="item.status != '' && !item.hasError">{{ item.product }}</span>
                </td>
              </template>
              <template v-slot:item.sellPrice="{ item }">
                <td style="width: 200px">{{ item.sellPrice == '' ? '' : formatPrice(item.sellPrice) }}</td>
              </template>
              <template v-slot:item.quantity="{ item }">
                <td style="width: 200px">{{ item.quantity }}</td>
              </template>
              <template v-slot:item.total="{ item }">
                <td style="width: 200px">{{ item.total == '' ? '' : formatPrice(item.total) }}</td>
              </template>
            </v-data-table>
            <v-divider />
          </v-card>
        </v-list-group>
      </v-list-group>
    </v-card-text>
    <!-- <v-card-actions class="text-right">
      <v-btn small @click="navToReportsPage" dark class="mr-4"
        >Generate Report</v-btn
      ></v-card-actions
    > -->
  </v-card>
</template>

<script>
  import { mapState } from 'vuex';

  export default {
    data() {
      return {
        expansionPanelModel: 0,
        loadingComponentModels: false,
        productHeaders: [
          { text: 'Type', value: 'type', width: '280px' },
          { text: 'Item', value: 'product', width: '280px' },
          { text: 'Price', value: 'sellPrice', width: '100px' },
          { text: 'QTY', value: 'quantity', width: '100px' },
          { text: 'Total', value: 'total', width: '100px' }
        ]
      };
    },
    props: {
      project: Object
    },
    methods: {
      consolidatedProductModels(subsystem) {
        let products = [];
        subsystem.componentModels.forEach((componentModel, index) => {
          var product = {
            status: componentModel.status
          };
          if (componentModel.sigMessageModel && !this.componentModelHasSettingsOnly(componentModel)) {
            // unconfigured product
            product.stepIndex = index;
            product.type = componentModel.name;
            product.product = componentModel.sigMessageModel.message;
            product.sellPrice = '';
            product.quantity = '';
            product.total = '';
            product.hasError = true;
            products.push(product);
          } else if (this.componentModelHasSettingsOnly(componentModel)) {
            // unconfigured product
            product.stepIndex = index;
            product.type = componentModel.name;
            product.product = componentModel.settingsParagraph;
            product.sellPrice = '';
            product.quantity = '';
            product.total = '';
            product.hasError = false;
            products.push(product);
          } else {
            componentModel.productModels.forEach((productModel) => {
              // add product data to componentModel Data
              product.stepIndex = index;
              product.type = componentModel.name;
              product.product = productModel.valid
                ? productModel.name
                : productModel.sigMessageModel
                ? productModel.sigMessageModel.message
                : 'Error: Product not Configured';
              product.hasError = !productModel.valid;
              product.sellPrice = productModel.customerSupplied ? '' : productModel.sellPrice;
              product.quantity = productModel.customerSupplied ? '' : productModel.quantity;
              product.total = productModel.customerSupplied ? '' : productModel.sellPrice * productModel.quantity;
              product.customerSupplied = productModel.customerSupplied;
              products.push(product);
              // add accessory data
              productModel.productAccessoryModels
                .filter((x) => x.selected)
                .forEach((accessoryModel) => {
                  var productAccessory = {};
                  productAccessory.type = '> Accessory';
                  productAccessory.product = accessoryModel.valid
                    ? accessoryModel.name
                    : accessoryModel.sigMessageModel
                    ? accessoryModel.sigMessageModel.message
                    : 'Error: Accessory not Configured';
                  productAccessory.sellPrice = accessoryModel.customerSupplied ? '' : accessoryModel.sellPrice;
                  productAccessory.quantity = accessoryModel.customerSupplied ? '' : accessoryModel.quantity;
                  productAccessory.total = accessoryModel.customerSupplied
                    ? ''
                    : accessoryModel.sellPrice * accessoryModel.quantity;
                  productAccessory.status = '';
                  productAccessory.customerSupplied = accessoryModel.customerSupplied;
                  productAccessory.hasError = !accessoryModel.valid;
                  products.push(productAccessory);
                });
            });
          }
        });

        return products;
      },
      /**
       * Returns the color for a specific step based on its status and current subsystem step.
       *
       * @param {Object} step - The step object.
       * @param {string} status - The status of the step (Valid, Warning, Error).
       * @returns {string} - The color code for the step.
       */
      getStepColor: function (step, status) {
        let color = '#200c40';
        if (!step) return color;

        if (status === 'Valid') color = '#30C473';
        else if (status === 'Warning') color = '#ffbd39';
        else if (status === 'Error') color = '#f52b40';

        if (this.isCurrentStep(step)) color = '#401881';

        return color;
      },
      /**
       * Returns the icon name based on the status of the given step.
       * @param {Object} step - The step object containing the status and component definition ID.
       * @returns {string} - The icon name corresponding to the step status.
       */
      getStepIcon: function (step) {
        let iconName = '';
        if (!step) return iconName;
        switch (step.status) {
          case 'Valid':
            iconName = 'mdi-check';
            break;
          case 'None':
            iconName = 'mdi-minus';
            break;
          default:
            iconName = 'mdi-alert';
        }
        if (this.isCurrentStep(step)) iconName = 'mdi-arrow-up';
        return iconName;
      },
      /**
       * Returns the CSS class name for the button associated with the given step.
       * The class name is determined based on the step's status and whether it is the current step.
       *
       * @param {Object} step - The step object containing the status and other properties.
       * @returns {string} - The CSS class name for the button.
       */
      getStepButtonClass: function (step) {
        let className = 'incompleteButton';

        if (!step) return className;
        if (step.status === 'Valid') className = 'validButton';
        else if (step.status === 'Warning') className = 'warningButton';
        else if (step.status === 'Error') className = 'errorButton';

        if (this.isCurrentStep(step)) className = 'currentButton';

        return className;
      },
      /**
       * TRUE if the componentModel has settings with no products
       */
      componentModelHasSettingsOnly(componentModel) {
        return componentModel.productModels.length == 0 && componentModel.productTypeId == null;
      },
      /**
       * Formats row background
       */
      getRowBackground(index) {
        return index % 2 == 0 ? '' : 'grey lighten-5';
      },
      /**
       * Returns a delimited list of product accessory settings
       */
      getAccessorySettings(accessory) {
        if (!accessory || !accessory.productSettingModels || accessory.productSettingModels.length == 0) return '';

        let resultString = '';
        accessory.productSettingModels.forEach((x) => {
          if (x.value) resultString += `${x.name}: ${x.value} ${x.valueSuffix}`;
        });

        return resultString;
      },
      /**
       * Gets the image for the input productModel
       */
      getImage(productModel) {
        return productModel.productImageModels && productModel.productImageModels.length > 0
          ? productModel.productImageModels[0].url
          : '';
      },
      /**
       * Gets subsystem details
       */
      getSubsystemDetails(systemId, subsystemId) {
        this.loadingComponentModels = true;
        this.$store.dispatch('configurator/getSubsystemDetails', subsystemId).then((detail) => {
          const currentSystem = this.project.systems.find((x) => x.id == systemId);
          if (!currentSystem) return;

          const currentSubsystem = currentSystem.subsystems.find((x) => x.id == subsystemId);
          if (!currentSubsystem) return;

          currentSubsystem.componentModels = detail.componentModels;
          this.loadingComponentModels = false;
        });
      }
    },
    computed: {
      ...mapState(['configurator'])
    }
  };
</script>

<style scoped>
  .stepButton {
    cursor: pointer;
  }
  .pointer {
    cursor: pointer;
  }
  .percentageColumn {
    max-width: 80px;
  }
  .accessoryRow {
    background-color: #fff;
    /* padding-left: 100px; */
  }
  .accessoryColumn {
    padding-left: 10px;
  }
  .text-right {
    display: flex;
    justify-content: flex-end;
  }
</style>
